export const CONFIG = {
  "PROJECTNAME": "asil",
  "COMPANYNAME": "Asil",
  "DFTLNGCODE": "de",
  "URL": "https://api.fbsshop.de",
  "PAYMENTSERVER": "https://stripe.mobiapi.de",
  "VENDORID": "10016410",
  "IMAGEURL": "/images",
  "PAYMENTSYSTEM": false,
  "BANNER": false,
  "BRANDS": false,
  "FLAG_ITEM_ON_HAND": false,
  "MENU_LOGO_BACKGROUND": false,
  "LOGO_LOGIN_BACKGROUND": true,
  "MENU_WHITE_BACKGROUND": false,
  "colors": {
    "primary": "#b40014",
    "primary100": "#f9ccd1",
    "light": "#b40014",
    "secondary": "#E2001A",
    "dark": "#e0241B",
    "siteColor3": "#fff",
    "menuSecondary": "#e0241B"
  }
};